import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const benefits = ['Se sienten más tranquilas con el dinero', 'Dejan de sabotearse', 'Toman mejores decisiones', 'Se posicionan distinto', 'Se permiten crecer sin culpa'];
  return <Section id="testimonials" background="gold-light" data-id="element-263">
      <div className="max-w-5xl mx-auto" data-id="element-264">
        <div className="text-center mb-16" data-id="element-265">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-266">
            Lo que empieza a pasar cuando cambias la mente
          </h2>
          <p className="text-xl text-gray-700" data-id="element-267">
            Las mujeres que aplican este proceso empiezan a notar que:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-268">
          {benefits.map((benefit, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-[#D4AF37]/10 flex flex-col items-center text-center hover:shadow-md transition-shadow" data-id="element-269">
              <div className="mb-4 text-[#D4AF37]" data-id="element-270">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 inline fill-current" data-id="element-271" />)}
              </div>
              <p className="font-medium text-gray-800 text-lg" data-id="element-272">{benefit}</p>
            </motion.div>)}

          {/* Summary Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="bg-black text-white p-6 rounded-xl shadow-lg flex flex-col items-center justify-center text-center md:col-span-2 lg:col-span-1" data-id="element-273">
            <p className="font-serif italic text-lg" data-id="element-274">
              "No porque 'se forzaron'. Sino porque ya no se pelean con el
              dinero."
            </p>
          </motion.div>
        </div>

        {/* Qualification Section (Who is this for) */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-275">
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-green-500" data-id="element-276">
            <h3 className="text-2xl font-bold mb-6 text-gray-900" data-id="element-277">
              Este programa es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-278">
              {['Eres profesional o emprendedora', 'Sientes que tu mindset te frena', 'Has crecido más que tu familia de origen', 'Quieres prosperar sin sentirte culpable', 'Buscas crecimiento con respeto cultural', 'Inviertes en ti cuando percibes calidad'].map((item, i) => <li key={i} className="flex items-start" data-id="element-279">
                  <span className="text-green-500 mr-3 font-bold" data-id="element-280">✔</span>
                  <span className="text-gray-700" data-id="element-281">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-red-400" data-id="element-282">
            <h3 className="text-2xl font-bold mb-6 text-gray-900" data-id="element-283">
              Y NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-284">
              {['Buscas fórmulas mágicas', 'Quieres lujo superficial sin trabajo interno', 'No estás lista para cuestionar creencias', 'Prefieres seguir igual “para no incomodar”'].map((item, i) => <li key={i} className="flex items-start" data-id="element-285">
                  <span className="text-red-400 mr-3 font-bold" data-id="element-286">✘</span>
                  <span className="text-gray-700" data-id="element-287">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}